import React from "react";
import { Counterparty } from "../../../common/types/counterparty";
import {
    RuleActionType,
    TransactionRuleAction,
} from "../../../common/types/transactionRule";
import { RuleCategoryAction } from "./RuleCategoryAction";
import { RuleEntityAction } from "./RuleEntityAction";
import { RuleAccountAction } from "./RuleAccountAction";
import { RuleMemoAction } from "./RuleMemoAction";
import { RuleCounterpartyAction } from "./RuleCounterpartyAction";
import { RuleAccountNameAction } from "./RuleAccountNameAction";
import { RuleClassesAction } from "./RuleClassesAction";

interface Props {
    action: TransactionRuleAction;
    counterparties: Counterparty[];
}

export const RuleAction: React.FC<Props> = ({ action, counterparties }) => {
    switch (action.actionType) {
        case RuleActionType.CATEGORY:
            return <RuleCategoryAction value={action.value as string} />;
        case RuleActionType.ENTITY:
            return <RuleEntityAction value={action.value as number} />;
        case RuleActionType.ACCOUNT_ID:
            return <RuleAccountAction value={action.value as string} />;
        case RuleActionType.ACCOUNT_NAME:
            return <RuleAccountNameAction value={action.value as string} />;
        case RuleActionType.MEMO:
            return <RuleMemoAction value={action.value as string} />;
        case RuleActionType.COUNTERPARTY:
            return (
                <RuleCounterpartyAction
                    value={action.value as string}
                    counterparties={counterparties}
                />
            );
        case RuleActionType.CLASS:
            return <RuleClassesAction value={action.value as string[]} />;
        default:
            return null;
    }
};
